import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {
    CustomerBillingAccountTransactionDto
} from "../../../../../model/dto/entity/customer-billing-account-transaction.dto";
import {BillingTransactionDirection} from "../../../../../enum/billing-transaction-direction.enum";

@Component({
    selector: 'bm-customer-account-transaction-item',
    templateUrl: './bm-customer-account-transaction-item.component.html',
    standalone: false
})
export class BmCustomerAccountTransactionItemComponent implements OnChanges {

    @Input() transaction: CustomerBillingAccountTransactionDto;
    @Output() onEdit = new EventEmitter<number>();

    isDebit: boolean;

    ngOnChanges() {
        this.isDebit = this.transaction.transactionDirection === BillingTransactionDirection.DEBIT;
    }

    onEditTransaction(): void {
        this.onEdit.emit(this.transaction.id);
    }
}
